// export const socketUrl = "http://localhost:5000";
export const socketUrl = "https://test.gsladmin.lilacinfotech.com";
